import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconOrganizationCorporate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 9.5C10.9142 9.5 11.25 9.83579 11.25 10.25V12.5C11.25 12.9142 10.9142 13.25 10.5 13.25C10.0858 13.25 9.75 12.9142 9.75 12.5V10.25C9.75 9.83579 10.0858 9.5 10.5 9.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.25 10.25C14.25 9.83579 13.9142 9.5 13.5 9.5C13.0858 9.5 12.75 9.83579 12.75 10.25V12.5C12.75 12.9142 13.0858 13.25 13.5 13.25C13.9142 13.25 14.25 12.9142 14.25 12.5V10.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 15.25C11.25 14.8358 10.9142 14.5 10.5 14.5C10.0858 14.5 9.75 14.8358 9.75 15.25V17.5C9.75 17.9142 10.0858 18.25 10.5 18.25C10.9142 18.25 11.25 17.9142 11.25 17.5V15.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.25 15.25C14.25 14.8358 13.9142 14.5 13.5 14.5C13.0858 14.5 12.75 14.8358 12.75 15.25V17.5C12.75 17.9142 13.0858 18.25 13.5 18.25C13.9142 18.25 14.25 17.9142 14.25 17.5V15.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 1.75C12.4142 1.75 12.75 2.08579 12.75 2.5V3.25H14C14.9665 3.25 15.75 4.0335 15.75 5V6.26373C16.875 6.38809 17.75 7.34186 17.75 8.5V20.25H19C19.4142 20.25 19.75 20.5858 19.75 21C19.75 21.4142 19.4142 21.75 19 21.75H5C4.58579 21.75 4.25 21.4142 4.25 21C4.25 20.5858 4.58579 20.25 5 20.25H6.25V8.5C6.25 7.34186 7.12501 6.38809 8.25 6.26373V5C8.25 4.0335 9.0335 3.25 10 3.25H11.25V2.5C11.25 2.08579 11.5858 1.75 12 1.75ZM7.75 8.5C7.75 8.08579 8.08579 7.75 8.5 7.75H15.5C15.9142 7.75 16.25 8.08579 16.25 8.5V20.25H7.75V8.5ZM14.25 5V6.25H9.75V5C9.75 4.86193 9.86193 4.75 10 4.75H14C14.1381 4.75 14.25 4.86193 14.25 5Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconOrganizationCorporate as ReactComponent };
